import { Model as e } from "../../model.js";
class i extends e {
  constructor(s) {
    super(), this.design = s.design, this.settings = s.settings;
  }
}
export {
  i as CheckoutModel
};
//# sourceMappingURL=checkout.model.js.map
